import { getSeedingProposalDetail as getSeedingProposalDetailApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import {
  type GetSeedingProposalDetailServiceRequest,
  GetSeedingProposalDetailServiceRequestSchema,
  type GetSeedingProposalDetailServiceResponse,
  GetSeedingProposalDetailServiceResponseSchema,
} from './get-seeding-proposal-detail.dto';
import { determineSeedingProposalScreenState } from './utils';

export const getSeedingProposalDetailService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetSeedingProposalDetailServiceRequestSchema),
    async (
      request: GetSeedingProposalDetailServiceRequest,
    ): Promise<GetSeedingProposalDetailServiceResponse> => {
      const apiResponse = await getSeedingProposalDetailApi(request);

      if (apiResponse.meta?.result === 'FAIL') {
        throw new Error(
          apiResponse.meta?.message ?? '시딩 제안형 캠페인 상세 조회에 실패했습니다.',
        );
      }

      const data = apiResponse.data;
      return {
        screenState: determineSeedingProposalScreenState(data),
        campaign: {
          ...data.campaign,
          // requiredHashtags 는 각 항목에 # 가 이미 포함됨 → 공백 join 만으로 표시·복사용 문자열 구성.
          hashtagText: data.campaign.requiredHashtags.join(' '),
        },
        goods: data.goods,
        participation: data.participation,
        fulfillments: data.fulfillments,
        contentSubmissions: data.contentSubmissions,
        deliveryAddress: data.deliveryAddress,
        penalty: data.penalty,
        shippingDeadlineDays: data.shippingDeadlineDays ?? null,
        estimatedShippingDeadlineAt: data.estimatedShippingDeadlineAt ?? null,
      };
    },
    validateServiceResponse(GetSeedingProposalDetailServiceResponseSchema),
  ),
);
